// This file is automatically generated. Do not edit it directly.
// (Edited once, 2026-10-22: `global.fetch` pins edge-function calls next to the database, lib/function-region.ts.)
import { createClient } from '@supabase/supabase-js';
import { fetchInFunctionRegion } from '@/lib/function-region';
import type { Database } from './types';
export const SUPABASE_PROJECT_ID = import.meta.env.VITE_SUPABASE_PROJECT_ID;
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: { fetch: fetchInFunctionRegion },
});